import { Box } from "@mui/material";
import UserList from "./UserList";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../../common/ErrorFallback";

const style = {
  pageContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: "100%",
  },
} as const;

function UserListContainer() {
  return (
    <Box data-testid="user-list-container" sx={style.pageContainer}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <UserList />
      </ErrorBoundary>
    </Box>
  );
}

export default UserListContainer;
